import React from 'react'

// styles
import { AboutUsStylesStylesContainer } from './styles/AboutUsStyles'

// includes
import Breadcrumbs from './Includes/Breadcrumbs'

// images
import aboutBG from 'assets/images/aboutBG.jpg'

export default function AboutUs(props) {
    // props
    const {
        currentRoute
    } = props

    return (
        <AboutUsStylesStylesContainer>
            <div className="container-fluid px-0">
                {/* <Breadcrumbs currentRoute={currentRoute} /> */}

                <div className="content">
                    {/* banner */}
                    <div className="page-banner" style={{ backgroundImage: `url(${aboutBG})` }}>
                        <div className="container-fluid">
                            <div className="inner text-center">
                                <p className="mb-0 text-white st-fw-800">To help people love how they live in moments that matter.</p>
                            </div>
                        </div>
                    </div>

                    {/* details */}
                    <div className="page-details">
                        <div className="container">
                            <div className="page-details-inner row">
                                {/* left */}
                                <div className="lt-sec col-12 col-md-8 mb-3 mb-md-0">
                                    <div className="inner">
                                        <p className="head st-fw-800 st-fs-20 mb-2">About Ruhlistic Decor</p>
                                        <p className="desc1 st-fs-17 mb-3">
                                            Ruhlistic Decor is a boutique design firm conceptualized and created by Ruhmeen Kaur who is an avid interior designer and has been a creator of novel spaces for several commercial businesses, home construction companies as well as individual clientele for over 10 years.
                                        </p>
                                        <div className="other-det d-flex">
                                            <div className="item">
                                                <p className="mb-0">
                                                    A deep love for unique design and vision for contemporary, transitional and industrial interiors inspired Ruhmeen to launch Ruhlistic Decor which houses carefully picked accents, art pieces, functional furniture, carefully curated gift items and other timeless design elements. Our products are one of a kind and are sure to bring your search for unexampled home dècor to a happy end.
                                                </p>
                                            </div>
                                            <div className="item">
                                                <p className="mb-0">
                                                    Ruhlistic Dècor brings to you exceptional quality products that have been ethically sourced from over 15 countries and are crafted to last. Our products will bring your vision to life and turn your space into a haven you seek to live, work and entertain in.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* right */}
                                <div className="rt-sec col-md-4">
                                    <div className="inner">
                                        <div className="frac mb-3">
                                            <p className="head st-fw-800 st-fs-20 mb-2">Media Inquiries</p>
                                            <p className="desc1 st-fs-17 mb-0">
                                                For all press and partnership inquiries, contact
                                                <span className="d-block st-fw-800">info@ruhlisticdecor.com.</span>
                                            </p>
                                        </div>
                                        <div className="frac">
                                            <p className="head st-fw-800 st-fs-20 mb-2">Contact Center</p>
                                            <p className="desc1 st-fs-17 mb-0">
                                                For questions and comments regarding your order or shopping experience, contact us through <span className="st-fw-800">Customer Service</span>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </AboutUsStylesStylesContainer>
    )
}
